export const PRICE_FILTER_SHORT_NAME = "priceRange"
export const priceDefault = [50, 250]

const sN = PRICE_FILTER_SHORT_NAME
const pD = priceDefault

export const PRICE_FILTER_CONFIG = {
         short_name: sN,
         default_values: pD,
         is_default: value => testPriceDefault(value), //right before clean up
         format_to_api: value => formatPriceForAPI(value), //strip out defaults; put into the correct api form. //IF we have the value using the short code, then let's format it
         format_from_url: value => formatPriceFromURL(value) //
       }


//we just do this for nice semantic names
export const testPriceDefault = value => {
    return isPriceRangeDefault(value)
}


export const isPriceRangeDefault = (value) => {
  if (
    value[0] === priceDefault[0] &&
    value[1] === priceDefault[1]
  ) {
    return true
  } else {
    return false
  }
}

export const buildPriceLabel = (labelSize, currentRange) => {

  let newLabel = ""

  if (isPriceRangeDefault(currentRange)) {
    if (labelSize === "long") {
      newLabel = "All Prices"
    } else {
      newLabel = "Price"
    }
  }
  if (
    currentRange[0] !== priceDefault[0] &&
    currentRange[1] === priceDefault[1]
  ) {
    newLabel = "$" + currentRange[0] + "+"
  }

  if (
    currentRange[0] !== priceDefault[0] &&
    currentRange[1] !== priceDefault[1]
  ) {
    newLabel = "$" + currentRange[0] + " - $" + currentRange[1]
  }

  if (
    currentRange[0] === priceDefault[0] &&
    currentRange[1] !== priceDefault[1]
  ) {
    newLabel = "$" + currentRange[0] + " - $" + currentRange[1]
  }

  return newLabel
}


export const formatPriceFromURL = value => {
  let cleanValue = null
  if (value) {
    if (value instanceof Array) {
      if (value.length === 2) {
        //cast them to numbers
        let minPrice = Number(value[0])
        let maxPrice = Number(value[1])
        if (!isNaN(minPrice) && !isNaN(maxPrice)) {
          if (minPrice < maxPrice) {
            //At somepoint we should round these to match the slider?
            //eh, doesn't matter. we'll do this later. only a problem if some one
            //manually messes this up.
            cleanValue = []
            cleanValue[0] = minPrice
            cleanValue[1] = maxPrice
          }
        }
      }
    }
  }
  return cleanValue
}

//api
export const formatPriceForAPI = (value) => {
    if (value) {
        return {
            min_price_cents : value[0] * 100,
            max_price_cents : value[1] * 100
        }
    }
    else {
        return {}
    }
}
